import BaseModel from './BaseModel';

/** Class representing a report. */
class Report extends BaseModel { }

Report.format_amount = (amount) => {
    return new Intl.NumberFormat('fr-CH', {
        style: 'decimal',
    }).format(amount)
}

Report.format_money = (amount, currency) => {
    return new Intl.NumberFormat('fr-CH', {
        currency,
        style: 'currency',
    }).format(amount)
}

/**
 * Fees total for report aggregates: sum of PSP + acquirer fees when provided by the API.
 * Falls back to effective − net for older report payloads without `fees`.
 *
 * @param {{ effective?: number, net?: number, fees?: number }|null|undefined} total
 * @returns {number}
 */
Report.total_fees_value = (total) => {
    if (total == null)
        return 0;
    const fees = total.fees;
    if (fees !== undefined && fees !== null && !Number.isNaN(Number(fees)))
        return Number(fees);
    const eff = Number(total.effective ?? 0);
    const net = Number(total.net ?? 0);
    return eff - net;
};

export default Report;
